export default {
  bioactiveSelected: null,
  fetchBoactiveBankList: false,
  fetchPreservedList: false,
  searchBioactive: null,
  reactivation:null
};
